export default {
  routes: [
    {
      name: 'schedules',
      path: '/directory/schedules',
      component: () => import('./views/TheSchedulePages.vue'),

    },

    {
      name: 'schedule',
      path: '/directory/schedules/:uuid',
      component: () => import('./views/TheSchedulePage.vue'),
    },
  ]
}
